
 <div *ngIf="showMessage" class="status-modal-box  transition delay scale-1" [ngClass]="{'show-modal-box': showMessage, 'hide-modal-box': !showMessage}">
  <div class="status-card transition w-100per position-fixed top-10 bg-white-color modal-box-card d-flex flex-y-center w-100per justify-space-between p-10-20 bdr-radius-10 mb-10">
    <div class="d-flex flex-y-center">
      <img
        src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/{{alertType=='error-box' ? 'red-circle-error.svg' :
          alertType=='success-box' ? 'green-sucess.svg' : 
          alertType=='warning-box' ? 'red-warning.svg' : 
          null }}"
        width="20px"
        height="20px"
        alt="alert-logo"
        class="mr-20"
      />
      <div class="ml-10">
        <h4 class="m-0 text-size-18 text-bold"
        [ngClass]="{'text-red': alertType=='error-box', 'text-orange-color': alertType=='warning-box', 'text-green' :  alertType=='success-box' }">
          {{alertType === "error-box"
          ? "Error"
          : alertType === "warning-box"
          ? "Warning"
          : alertType === "success-box"
          ? "Success"
          : null}}
        </h4>
        <small className="text-dark-grey-color text-size-12 mt-5 mb-0">
         {{message}}
        </small>
      </div>
    </div>
    <img
      src="{{commonService.aws_asset_url}}/_assets/icons/red-close.svg"
      alt="close-btn"
      (click)="hideError()"
      className=" close-btn"
    />
  </div>
</div>

<button type="button" hidden  #openSuccessModal data-toggle="modal" data-target="#successModal"></button>

<!-- Modal -->
<div id="successModal" class="modal fade" role="dialog" data-backdrop="false">
    <div class="modal-dialog transaction-creation-modal">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <span class="messageFont">
                    <span>
                        {{message}} 
                    </span>
                    <a 
                        *ngIf="createdClientCode != ''"
                         href="javascript:void(0)"
                        (click)="viewClient(createdClientId)">
                            {{createdClientCode}}
                    </a>
                </span>
            <button type="button" class="close" (click)="closeSuccesModal()">&times;</button>
            </div>

            <div class="modal-body">
                <p>Do you want to create new Client or view newly created Client ?</p>
            </div>
          
            <div class="modal-footer justify-content-center" >
                <button tabIndex="1" tabindex="1" type="button" class="btn btn-primary " (click)="viewClient(createdClientId)">
                    View
                </button>
                <button tabIndex="3" tabindex="3" type="button" class="btn btn-primary" (click)="closeSuccesModal()">
                    Create New
                </button>
            </div>
        </div>
    </div>
</div>

<div class="ledger-container  ">
  <div class="row tab-nav pl-0 pr-0">
    <!-- <div class="col-sm-4 pl-0">
        <ul class="list-inline list-unstyled p-0 m-0">
            <li class="active page-title text-uppercase cursor"> View Client</li>
        </ul>
    </div> -->
    <div class="col-sm-4 ">
      <ul class="page-nav d-flex align-item-center list-inline list-unstyled p-0 m-0">
          <li [routerLink]="['/']"
              class="text-grey text-capitalize cursor  hover-text-primary transition"> Master</li>
          <li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg" alt=""></li>
          <li [routerLink]="['/']"
              class="text-grey text-capitalize cursor  hover-text-primary transition"> Client</li>
          <li><img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/angle-left.svg" alt=""></li>
          <li class="text-grey text-capitalize cursor text-primary transition"> Create Client</li>
      </ul>
  </div>
</div>



    <form [formGroup]="clientForm" [ngClass]="{'d-none': !newClient}">
      <div class="custom-form form-container mt-4 pl-15 pr-15" style="    width: 600px;
      margin: 20px 0 ">

    <div class="text-input-group d-flex justify-content-between">
      
      <div class="select-field text-input-field" [ngClass]="{'mr-2': isHQBranch}">
        <select class="input-field" tabIndex="1" formControlName="parent_id" [ngClass]="{'error-field': (!clientForm.controls.parent_id.valid && submitted),
          'success-field' : clientForm.controls.parent_id.valid && clientForm.controls.parent_id.dirty}">
          <option selected disabled>SELECT</option>
          <ng-container *ngIf="groupList != undefined">
            <option *ngFor="let item of groupList" value="{{item.id}}">{{item.name}}</option>
          </ng-container>
        </select>
        <label
          [ngClass]="{'error-label': clientForm.controls.parent_id.invalid && clientForm.controls.parent_id.dirty || (!clientForm.controls.parent_id.valid && submitted)}">Group
          <ng-container
            *ngIf="clientForm.controls.parent_id.invalid && clientForm.controls.parent_id.dirty || (!clientForm.controls.parent_id.valid && submitted)">
            <i class="fa fa-info-circle ml-2" title="Group Required" aria-hidden="true"></i>
          </ng-container>
        </label>
      </div>


    </div>
      

      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="name" tabIndex="2"
            formControlName="name" type="text" [ngClass]="{'error-field': clientForm.controls.name.invalid && clientForm.controls.name.dirty  || (!clientForm.controls.name.valid && submitted),
              'success-field' : clientForm.controls.name.valid && clientForm.controls.name.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.name.invalid && clientForm.controls.name.dirty || (!clientForm.controls.name.valid && submitted)}">Client Name
            <span class="text-danger">*</span>
            <ng-container
              *ngIf="clientForm.controls.name.invalid && clientForm.controls.name.dirty || (!clientForm.controls.name.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Account Required" aria-hidden="true"></i>
            </ng-container>
          </label>
  
        </div>
        <div class="text-input-field">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="contact_person" tabIndex="2"
            formControlName="contact_person" type="text" [ngClass]="{'error-field': clientForm.controls.contact_person.invalid && clientForm.controls.contact_person.dirty  || (!clientForm.controls.contact_person.valid && submitted),
              'success-field' : clientForm.controls.contact_person.valid && clientForm.controls.contact_person.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.contact_person.invalid && clientForm.controls.contact_person.dirty || (!clientForm.controls.contact_person.valid && submitted)}">Contact Person
            <span class="text-danger">*</span>
            <ng-container
              *ngIf="clientForm.controls.contact_person.invalid && clientForm.controls.contact_person.dirty || (!clientForm.controls.contact_person.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Contact Person Required" aria-hidden="true"></i>
            </ng-container>
          </label>
  
        </div>
      </div>
      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="account_legal_name" 
            formControlName="account_legal_name" type="text"/>
          <label>Client Legal Name</label>
        </div>
      </div>
      

      <div class="text-input-field">
        <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="address_1" tabIndex="3"
          formControlName="address_1" type="text" [ngClass]="{'error-field': clientForm.controls.address_1.invalid && clientForm.controls.address_1.dirty || (!clientForm.controls.address_1.valid && submitted),
            'success-field' : clientForm.controls.address_1.valid && clientForm.controls.address_1.dirty }" />
        <label
          [ngClass]="{'error-label': clientForm.controls.address_1.invalid && clientForm.controls.address_1.dirty || (!clientForm.controls.address_1.valid && submitted)}">Address

          <ng-container
            *ngIf="clientForm.controls.address_1.invalid && clientForm.controls.address_1.dirty || (!clientForm.controls.address_1.valid && submitted)">
            <i class="fa fa-info-circle ml-2" title="Required Address" aria-hidden="true"></i>
          </ng-container>
        </label>

      </div>

      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2">
          <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="4"
            formControlName="country_id" (change)="getStates($event.target.value)">
            <option *ngFor="let country of countryArr" value="{{country.location_id}}">{{country.name}}</option>
          </select>
          <label>Country</label>
        </div>

        <div class="text-input-field mr-2">
          <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="5"
            formControlName="state_id" (change)="getCities($event.target.value)">
            <option *ngFor="let state of stateArr" value="{{state.location_id}}">{{state.name}}</option>
          </select>
          <label>State</label>
        </div>


        <div class="text-input-field">
          <select class="input-field" oninput="this.value = this.value.toUpperCase()" tabIndex="6"
            formControlName="city_id" (change)="getCityName($event.target.value)">
            <option *ngFor="let city of cityArr" value="{{city.location_id}}">{{city.name}}</option>
          </select>
          <label>City</label>
        </div>
      </div>

      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2" *ngIf="isTenantIndian">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="gst_number" tabIndex="7"
            formControlName="gst_number" type="text" maxlength="15"
            pattern="^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$"
            [ngClass]="{'error-field': clientForm.controls.gst_number.invalid && clientForm.controls.gst_number.dirty || (!clientForm.controls.gst_number.valid && submitted),
            'success-field' : clientForm.controls.gst_number.valid && clientForm.controls.gst_number.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.gst_number.invalid && clientForm.controls.gst_number.dirty} || (!clientForm.controls.gst_number.valid && submitted)">
            GST NUMBER
            <ng-container
              *ngIf="clientForm.controls.gst_number.invalid && clientForm.controls.gst_number.dirty || (!clientForm.controls.gst_number.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Invalid GST Number ( ex: 12ABCDE1234F1Z3)"
                aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>

        <div class="text-input-field" *ngIf="isTenantIndian">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="gst_expiry_date" tabIndex="8"
            formControlName="gst_expiry_date" type="date"
            [ngClass]="{'error-field': clientForm.controls.gst_expiry_date.invalid && clientForm.controls.gst_expiry_date.dirty  || (!clientForm.controls.gst_expiry_date.valid && submitted),
              'success-field' : clientForm.controls.gst_expiry_date.valid && clientForm.controls.gst_expiry_date.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.gst_expiry_date.invalid && clientForm.controls.gst_expiry_date.dirty}  || (!clientForm.controls.gst_expiry_date.valid && submitted)">Expiry
            Date
            <ng-container
              *ngIf="clientForm.controls.gst_expiry_date.invalid && clientForm.controls.gst_expiry_date.dirty  || (!clientForm.controls.gst_expiry_date.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="required expiry date" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>

        <div class="text-input-field" *ngIf="!isTenantIndian">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="vat_number" tabIndex="7"
            formControlName="vat_number" type="text" maxlength="20"
            [ngClass]="{'error-field': clientForm.controls.vat_number.invalid && clientForm.controls.vat_number.dirty || (!clientForm.controls.vat_number.valid && submitted),
            'success-field' : clientForm.controls.vat_number.valid && clientForm.controls.vat_number.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.vat_number.invalid && clientForm.controls.vat_number.dirty} || (!clientForm.controls.vat_number.valid && submitted)">
            {{vatAlternetname}} NUMBER
          </label>
        </div>
      </div>
      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="telephone" tabIndex="9"
            formControlName="telephone" type="text" pattern="([0-9]+)" [ngClass]="{'error-field': clientForm.controls.telephone.invalid && clientForm.controls.telephone.dirty ,
          'success-field' : clientForm.controls.telephone.valid && clientForm.controls.telephone.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.telephone.invalid && clientForm.controls.telephone.dirty}">Telephone
            <ng-container *ngIf="clientForm.controls.telephone.invalid && clientForm.controls.telephone.dirty">
              <i class="fa fa-info-circle ml-2" title="Invalid Telephone Number" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>
        <div class="text-input-field">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="mobile_no" minlength="10"
            maxlength="15" tabIndex="10" formControlName="mobile_no" type="text" pattern="([0-9]+)" [ngClass]="{'error-field': clientForm.controls.mobile_no.invalid && clientForm.controls.mobile_no.dirty  || (!clientForm.controls.mobile_no.valid && submitted),
          'success-field' : clientForm.controls.mobile_no.valid && clientForm.controls.mobile_no.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.mobile_no.invalid && clientForm.controls.mobile_no.dirty  || (!clientForm.controls.mobile_no.valid && submitted)}">Mobile
            No.
            <ng-container
              *ngIf="clientForm.controls.mobile_no.invalid && clientForm.controls.mobile_no.dirty  || (!clientForm.controls.mobile_no.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Invalid Mobile Number" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>
      </div>
      <div class="text-input-group d-flex justify-content-between">
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="primary_email" tabIndex="11"
            formControlName="primary_email" type="text" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,100})+$"
            [ngClass]="{'error-field': clientForm.controls.primary_email.invalid && clientForm.controls.primary_email.dirty  || (!clientForm.controls.primary_email.valid && submitted),
          'success-field' : clientForm.controls.primary_email.valid && clientForm.controls.primary_email.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.primary_email.invalid && clientForm.controls.primary_email.dirty  || (!clientForm.controls.primary_email.valid && submitted)}">Email
            #1<ng-container
              *ngIf="clientForm.controls.primary_email.invalid && clientForm.controls.primary_email.dirty  || (!clientForm.controls.primary_email.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Invalid Email" aria-hidden="true"></i>
            </ng-container>
          </label>

        </div>

        <div class="text-input-field">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="secondary_email"
            tabIndex="12" formControlName="secondary_email" type="text"
             [ngClass]="{'error-field': clientForm.controls.secondary_email.invalid && clientForm.controls.secondary_email.dirty,
          'success-field' : clientForm.controls.secondary_email.valid && clientForm.controls.secondary_email.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.secondary_email.invalid && clientForm.controls.secondary_email.dirty}">Email
            #2 <ng-container
              *ngIf="clientForm.controls.secondary_email.invalid && clientForm.controls.secondary_email.dirty">
              <i class="fa fa-info-circle ml-2" title="Invalid Email" aria-hidden="true"></i>
            </ng-container>
          </label>

        </div>
      </div>
      <div class="text-input-group d-flex justify-content-between" *ngIf="isTenantIndian">
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="lut_number"
            formControlName="lut_number" type="text" [ngClass]="{'error-field': clientForm.controls.lut_number.invalid && clientForm.controls.lut_number.dirty ,
          'success-field' : clientForm.controls.lut_number.valid && clientForm.controls.lut_number.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.lut_number.invalid && clientForm.controls.lut_number.dirty}">LUT Number
            <ng-container *ngIf="clientForm.controls.lut_number.invalid && clientForm.controls.lut_number.dirty">
              <i class="fa fa-info-circle ml-2" title="Invalid LUT Number Number" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>
        <div class="text-input-field">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="vat_number" minlength="10"
             formControlName="vat_number" type="text" [ngClass]="{'error-field': clientForm.controls.vat_number.invalid && clientForm.controls.vat_number.dirty  || (!clientForm.controls.vat_number.valid && submitted),
          'success-field' : clientForm.controls.vat_number.valid && clientForm.controls.vat_number.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.vat_number.invalid && clientForm.controls.vat_number.dirty  || (!clientForm.controls.vat_number.valid && submitted)}">VAT Number<ng-container
              *ngIf="clientForm.controls.vat_number.invalid && clientForm.controls.vat_number.dirty  || (!clientForm.controls.vat_number.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Invalid Mobile Number" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>
      </div>
      


      <ng-container *ngIf="!isTenantIndian">
        <div class="text-input-group d-flex justify-content-between">
        
          <div class="select-field text-input-field mr-3">
            <select id="selectscroll" class="input-field" tabIndex="1" formControlName="currency" (change)="currencyChange($event.target.value)" >
              <option value="INR">INR</option>
              <option value="CAD">CAD</option>
                <option value="USD">USD</option>
                <option value="AED">AED</option>
                <option value="EURO">EURO</option>
            </select>
            <label>CURRENCY</label>
          </div>
          <div class="text-input-field mr-3">
            <input class="input-field" style="    width: 185px;" oninput="this.value = this.value.toUpperCase()"
              name="currency" tabIndex="13" formControlName="currency_rate" type="text" maxlength="10"
              [ngClass]="{'error-field': clientForm.controls.currency_rate.invalid && clientForm.controls.currency_rate.dirty,
          'success-field' : clientForm.controls.currency_rate.valid && clientForm.controls.currency_rate.dirty}" />
            <label
              [ngClass]="{'error-label': clientForm.controls.currency_rate.invalid && clientForm.controls.currency_rate.dirty}">CURRENCY RATE<ng-container *ngIf="clientForm.controls.currency_rate.invalid && clientForm.controls.currency_rate.dirty">
                <i class="fa fa-info-circle ml-2" title="Invalid pan number" aria-hidden="true"></i>
              </ng-container>
            </label>
          </div>
          <div class="text-input-group d-flex justify-content-between">
            <div class="text-input-field" style="    width: 185px;">
              <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="local_balance" tabIndex="13"
            formControlName="local_balance"  type="text" [ngClass]="{'error-field': clientForm.controls.local_balance.invalid && clientForm.controls.local_balance.dirty,
          'success-field' : clientForm.controls.local_balance.valid && clientForm.controls.local_balance.dirty}" (input)="changeCurrentAmount($event)" />
          <label
            [ngClass]="{'error-label': clientForm.controls.local_balance.invalid && clientForm.controls.local_balance.dirty}">AMOUNT
            <ng-container *ngIf="clientForm.controls.local_balance.invalid && clientForm.controls.local_balance.dirty">
              <i class="fa fa-info-circle ml-2" title="Invalid amount" aria-hidden="true"></i>
            </ng-container>
          </label>
            </div>
          </div>
        </div>
      </ng-container>



      <div class="text-input-group d-flex justify-content-between">
        <div class="w-50 d-flex mr-2">
          
          <div class="text-input-field ">
            <!-- <label>Remarks</label> -->
            <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="balance" tabIndex="13" [readonly]="!isTenantIndian"
              formControlName="balance" pattern="^\d*(\.\d{0,8})?$" type="text" [ngClass]="{'error-field': clientForm.controls.balance.invalid && clientForm.controls.balance.dirty,
            'success-field' : clientForm.controls.balance.valid && clientForm.controls.balance.dirty}" />
            <label
              [ngClass]="{'error-label': clientForm.controls.balance.invalid && clientForm.controls.balance.dirty}">Opening
              Balance
              <ng-container *ngIf="clientForm.controls.balance.invalid && clientForm.controls.balance.dirty">
                <i class="fa fa-info-circle ml-2" title="Invalid opening balance" aria-hidden="true"></i>
              </ng-container>
            </label>
          </div>
        </div>
        <div class="w-50 d-flex">
          <div class="select-field text-input-field mr-2">
            <select class="input-field" tabIndex="14" formControlName="sub_ledger">
              <option value="CC001A">CASH</option>
              <option value="CC001B">CREDIT</option>
            </select>
            <label> Sub Ledger </label>
          </div>
          <div style="width: 60px;" class="select-field text-input-field">
            <select class="input-field" tabIndex="15" formControlName="balance_type" style="padding: 2px;">
              <option value="debit">DR</option>
              <option value="credit">CR</option>
            </select>
          </div>
        </div>
      </div>


      <div class="text-input-group d-flex justify-content-between">


        <div class="text-input-field mr-2">
          <label class="ngauto-label" for="sales_person"
            [ngClass]="{'error-label': clientForm.controls.sales_person_name.invalid && clientForm.controls.sales_person_name.dirty || (!clientForm.controls.sales_person_name.valid && submitted)}">Sales
            Person
            <ng-container
              *ngIf="clientForm.controls.sales_person_name.invalid && clientForm.controls.sales_person_name.dirty || (!clientForm.controls.sales_person_name.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Sales Person Required" aria-hidden="true"></i>
            </ng-container>
          </label>
          <div class="ng-autocomplete w-100" (focus)="focusSalesPerson($event)" tabIndex="16">
            <ng-autocomplete #salesPersonAC
              [ngClass]="{'error-ng-field': clientForm.controls.sales_person_name.invalid && clientForm.controls.sales_person_name.dirty || (!clientForm.controls.sales_person_name.valid && submitted),
              'success-ng-field' : clientForm.controls.sales_person_name.valid && clientForm.controls.sales_person_name.dirty }"
              [data]="salesPersonArr" id="sales_person" [searchKeyword]="keyword"
              (inputChanged)='getSalesPerson($event)' [itemTemplate]="itemTemplate"
              (selected)="selectSalesPerson($event)" formControlName="sales_person_name"
              [notFoundTemplate]="notFoundTemplate">
            </ng-autocomplete>
            <ng-template #itemTemplate let-item>
              <a innerHTML='<span class="colr-1">{{item.name}}
                                    ({{item.account_code}})</span><br />
                                <span class="colr-2">{{item.primary_email}}</span><br />'>
              </a>
            </ng-template>

            <ng-template #notFoundTemplate let-notFound>
              <div [innerHTML]="notFound"></div>
            </ng-template>
          </div>
        </div>

        <div class="text-input-field">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="account_code" tabIndex="17"
            formControlName="account_code" type="text" />
          <label
            [ngClass]="{'error-label': clientForm.controls.account_code.invalid && clientForm.controls.account_code.dirty  || (!clientForm.controls.account_code.valid && submitted)}">Account
            Code (If Any)
          </label>

        </div>


      </div>

      <!-- MSME option -->
        <div class="text-input-group d-flex justify-content-between" *ngIf = "msme_config=='true'" >
    <div class="text-input-field mr-2">
      <label class="ngauto-label" for="msme_category"
        [ngClass]="{'error-label': clientForm.controls.msme_category.invalid && clientForm.controls.msme_category.dirty || (!clientForm.controls.msme_category.valid && submitted)}">
        MSME Category
        <ng-container
          *ngIf="clientForm.controls.msme_category.invalid && clientForm.controls.msme_category.dirty || (!clientForm.controls.msme_category.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Category Required" aria-hidden="true"></i>
        </ng-container>
      </label>
      
      <select class="input-field" tabIndex="18" formControlName="msme_category" (change)="onChangeClient($event)">
        <option value="">Select Category</option>
        <option value="micro">MICRO</option>
        <option value="small">SMALL</option>
        <option value="medium">MEDIUM</option>
      </select>
    </div>

    <div class="text-input-field">
       <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="aadhar_no"
            formControlName="aadhar_no" type="text" [ngClass]="{'error-field': clientForm.controls.aadhar_no.invalid && clientForm.controls.aadhar_no.dirty ,
          'success-field' : clientForm.controls.aadhar_no.valid && clientForm.controls.aadhar_no.dirty}" />
      <label  for="aadhar_no"
        [ngClass]="{'error-label': clientForm.controls.aadhar_no.invalid && clientForm.controls.aadhar_no.dirty || (!clientForm.controls.aadhar_no.valid && submitted)}">
        Udyog AAdhar No.
        <ng-container
          *ngIf="clientForm.controls.aadhar_no.invalid && clientForm.controls.aadhar_no.dirty || (!clientForm.controls.aadhar_no.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Udyog AAdhar No. Required" aria-hidden="true"></i>
        </ng-container>
      </label>
    </div>
        </div>

    <!-- New Category List and Source List section -->
    <div class="text-input-group d-flex justify-content-between" *ngIf="showCategoryField || showSourceField">
    <div class="text-input-field mr-2">
      <label class="ngauto-label" for="category_list"
        [ngClass]="{'error-label': clientForm.controls.category_list.invalid && clientForm.controls.category_list.dirty || (!clientForm.controls.category_list.valid && submitted)}">
        Category
        <ng-container
          *ngIf="clientForm.controls.category_list.invalid && clientForm.controls.category_list.dirty || (!clientForm.controls.category_list.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Category Required" aria-hidden="true"></i>
        </ng-container>
      </label>
      
      <select class="input-field" tabIndex="18" formControlName="category_list">
        <option value="">Select Category</option>
        <option *ngFor="let category of categoryOptions" [value]="category">{{category}}</option>
      </select>
    </div>

    <div class="text-input-field">
      <label class="ngauto-label" for="source_list"
        [ngClass]="{'error-label': clientForm.controls.source_list.invalid && clientForm.controls.source_list.dirty || (!clientForm.controls.source_list.valid && submitted)}">
        Source
        <ng-container
          *ngIf="clientForm.controls.source_list.invalid && clientForm.controls.source_list.dirty || (!clientForm.controls.source_list.valid && submitted)">
          <i class="fa fa-info-circle ml-2" title="Source Required" aria-hidden="true"></i>
        </ng-container>
      </label>
      
      <select class="input-field" tabIndex="19" formControlName="source_list">
        <option value="">Select Source</option>
        <option *ngFor="let source of sourceOptions" [value]="source">{{source}}</option>
      </select>
    </div>
    </div>

      <div class="text-input-group d-flex justify-content-between">
        <ng-container *ngIf="isTesoyBoult">
        <div class="text-input-field mr-2">
          <label class="ngauto-label" for="client_type"
            [ngClass]="{'error-label': clientForm.controls.client_type.invalid && clientForm.controls.client_type.dirty || (!clientForm.controls.client_type.valid && submitted)}">
            Client Type
            <ng-container
              *ngIf="clientForm.controls.client_type.invalid && clientForm.controls.client_type.dirty || (!clientForm.controls.client_type.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Client Type Required" aria-hidden="true"></i>
            </ng-container>
          </label>

          
            <select class="input-field"  tabIndex="18"
              formControlName="client_type" (change)="onChangeClient($event)">
              <option value="">Select</option>
              <option value="master">Master</option>
              <option value="child">Child</option>
            </select>
         

        </div>

        <div class="text-input-field" *ngIf="clientForm.controls.client_type.value == 'child'">
          <label class="ngauto-label" for="parent_account_code"
            [ngClass]="{'error-label': clientForm.controls.parent_account_code.invalid && clientForm.controls.parent_account_code.dirty || (!clientForm.controls.parent_account_code.valid && submitted)}">
            Parent Account
            <ng-container
              *ngIf="clientForm.controls.parent_account_code.invalid && clientForm.controls.parent_account_code.dirty || (!clientForm.controls.parent_account_code.valid && submitted)">
              <i class="fa fa-info-circle ml-2" title="Parent Account Required" aria-hidden="true"></i>
            </ng-container>
          </label>

          <select class="input-field"  tabIndex="19"  formControlName="parent_account_code" >
            <ng-container *ngIf="parentClients != undefined">
              <option value="">Select</option>
              <option *ngFor="let item of parentClients" value="{{item.account_code}}">{{item.name}}({{item.account_code}})</option>
            </ng-container>
          </select>
        </div>
      </ng-container>
        <div class="text-input-field mr-2">
          <input class="input-field" oninput="this.value = this.value.toUpperCase()" name="pan_number" tabIndex="20"
            formControlName="pan_number" type="text" maxlength="10" pattern="([a-zA-Z]{5})(\d{4})([a-zA-Z]{1})$"
            [ngClass]="{'error-field': clientForm.controls.pan_number.invalid && clientForm.controls.pan_number.dirty,
            'success-field' : clientForm.controls.pan_number.valid && clientForm.controls.pan_number.dirty}" />
          <label
            [ngClass]="{'error-label': clientForm.controls.pan_number.invalid && clientForm.controls.pan_number.dirty}">PAN
            NO. <ng-container *ngIf="clientForm.controls.pan_number.invalid && clientForm.controls.pan_number.dirty">
              <i class="fa fa-info-circle ml-2" title="Invalid pan number" aria-hidden="true"></i>
            </ng-container>
          </label>
        </div>
      </div>

      <div class="text-input-group">
        <div class="text-input-field mr-2">
          <textarea tabIndex="21" class="input-field" formControlName="remarks"
            oninput="this.value = this.value.toUpperCase()" rows="2"></textarea>
          <label>Remarks</label>
        </div>
      </div>
      

      <div class="form-check">
        <input class="radio-ui mr-2" type="checkbox" formControlName="is_memo_account" id="isMemo">
        <label cclass="radio-label" style="transform: none;font-size: 12px;margin-bottom: 0;" for="isMemo">
          Is Memo Account
        </label>
      </div>

      
  
      <!-- Checkbox for is_branch -->
      <div class="form-check">
        <input class="radio-ui mr-2" type="checkbox" formControlName="is_branch" id="isBranch">
        <label class="radio-label" style="transform: none;font-size: 12px;margin-bottom: 0;" for="isBranch">
          Is Branch
        </label>
      </div>
      <!-- <span class="info alert-warning" *ngIf="showMessage && alertType == 'success-box' && createdClientId != ''">Client
        created. <a [routerLink]="['/master/policy/default-client-policy', createdClientId]">Click here to update
          policy.</a></span> -->
          <!-- <div class="select-field text-input-field" *ngIf="isHQCompany">
            <label for="selectedCompany" style="font-size: 13px; font-weight: 500!important;">Company</label>
            <ng-container *ngFor="let item of companies">
                <div *ngIf="item?.associate_company_id!==null" class="input-fiel" style="display: flex;align-items: center;">
                  <input class="radio-ui mr-2" type="checkbox"  (change)="handleCompanyChange($event,item?.tenant_company_name)"  />
                  <label class="radio-label" style="transform: none;font-size: 12px;margin-bottom: 0;" >{{item?.tenant_company_name}}</label>
                </div>
            </ng-container>
          </div> -->
          <div class="select-field text-input-field" *ngIf="isHQBranch">
            <label for="selectedBranch" style="font-size: 13px; font-weight: 500!important;">Branch</label>
            <ng-container *ngFor="let item of branches">
                <div *ngIf="item?.branch_type=='BRANCH'" class="input-fiel" style="display: flex;align-items: center;">
                  <input class="radio-ui mr-2" type="checkbox"  (change)="handleValueChange($event,item?.branch_name)"  />
                  <label class="radio-label" style="transform: none;font-size: 12px;margin-bottom: 0;" >{{item?.branch_name}}</label>
                </div>
            </ng-container>
          </div>


        </div>
        <div class="btn-field bottom-btns-container mt-30 d-flex align-item-center justify-content-end  ml-0 mr-0"> 
         
          <div>
            <button type="button" class="btn-style bg-green mr-3" (click)="reset()">Reset</button>     
          <button type="button" class="btn-style  bg-purple" tabIndex="22" #confirmModal (click)="openConfirmModal()"
          data-toggle="modal" data-target="#confirmationModal">Save</button>
          </div>  
      </div>
    </form>

  
</div>

<div class="modal fade" id="confirmationModal" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4>Confirmation</h4>
        <button type="button" class="close" #closeModal data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Create {{clientForm?.value?.name}} ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-style mr-3" tabIndex="23" data-dismiss="modal">Close</button>
        <button type="button" class="btn-style bg-green" (click)="checkBalance()" tabIndex="24">Yes</button>
      </div>
    </div>
  </div>
</div>

<button type="button" hidden #confirmUpdateModal data-toggle="modal" data-target="#updateconfirmationModal"></button>
<div id="updateconfirmationModal" class="modal fade" role="dialog" data-backdrop="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Confirmation</h4>
        <button type="button" #closeUpdateModal class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        There is a mismatch of amount {{remainingAmount}} in your opening balance. It will be adjusted in the Opening Balance Adjustment account. Would you like to proceed?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn-style mr-3" 
        data-dismiss="modal">Close</button>
        <button type="button" class="btn-style bg-green" (click)="updateOpeningBalancecombine()" >CREATE</button>
      </div>
    </div>
  </div>
</div>

<button type="button" hidden #openWarningModal data-toggle="modal" data-target="#warningModal"></button>
<div id="warningModal" class="modal fade" role="dialog" data-backdrop="false">
  <div class="modal-dialog transaction-creation-modal">
    <div class="modal-content">

      
      <div class="modal-header">
        <img src="{{commonService.aws_asset_url}}/_assets/icons/light-mode/red-warning.svg" width="20px" height="20px"
            alt="alert-logo" class="mr-20" />
        <span class="messageFont">
          <span>Warning</span>
        </span>
        <button type="button" #closeWarningModal class="close" data-dismiss="modal">&times;</button>
      </div>

      <div class="modal-body">
        <p [innerHTML]="warningMessage"></p>
      </div>
    
      <div class="modal-footer justify-content-center">
        <button type="button"
                class="btn btn-primary"
                (click)="submit(true)">
          Create, I Understand
        </button>
        <button type="button"
                class="btn btn-primary"
                data-dismiss="modal">
          Cancel
        </button>
      </div>

    </div>
  </div>
</div>